import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

import Footer from 'components/common/Footer';
import MessageBox from 'components/common/MessageBox';
import * as types from 'reducer/actionTypes';

class Login extends React.Component {
	onClickLogin = (e) => {
		e.preventDefault();
		this.props.fetchLogin(this.props.login.id, this.props.login.pw, this.props.history)
	}

	onKeyPress = (e) => {
		if(e.key === 'Enter'){
			this.onClickLogin(e);
		}
	}

	render(){
		const {t} = this.props;

		return(
			<div className="wrap login">
				<div className="login_wrap">
					<div className="header">
                        <h1 className={t('lang')}><span></span></h1>
					</div>
					<div className="login_box">
						<h2>{t('login.title')}</h2>
						<div>{t('login.title.description')}</div>
						<input type="text" className="item_input login_id" placeholder={t('login.input.id.placeholder')} onChange={this.props.setUserId} onKeyPress={this.onKeyPress}/>
						{/* <div className="error">에러 메세지</div> */}

						<input type="password" className="item_input login_pw" placeholder={t('login.input.password.placeholder')} onChange={this.props.setUserPw} onKeyPress={this.onKeyPress}/>
						{/* <div className="error">에러 메세지</div> */}

						<div className="btn_wrap">
							<button className="btn_text_b" onClick={this.onClickLogin}>{t('login.button.comfirm')}</button>
						</div>
					</div>
				</div>
				<MessageBox/>
				<Footer/>
			</div>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		login: reducers.login
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		setUserId: (e) => {dispatch({type: types.SET_USER_ID, id: e.target.value})},
		setUserPw: (e) => {dispatch({type: types.SET_USER_PW, pw: e.target.value})},
		//saga
		fetchLogin: (id,pw,history) => {dispatch({type: types.FETCH_LOGIN_REQUEST, id: id, pw: pw, history:history})}
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Login))
